import { ROUTES_NAMES } from "constants/name.routes"
import { NavExternal, NavItem, NavLinkExternal, NavMenu } from "./styles"
import { IconLoginExternal, LogoExternal, LogoChristmasExternal } from "./svg"
import { Link } from "react-router-dom"
import { isChristmas } from 'helper/date'

export const NavBarExternal = ({ pathname }: { pathname: string }) => {
    let logo = <LogoExternal />
    if (isChristmas()) {
        logo = <LogoChristmasExternal />
    }
    return (
        <>
            <NavExternal data-testid="test-external-nav">
                <NavItem>
                    <Link to={ROUTES_NAMES.notifyEvent} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        {logo}
                    </Link>
                </NavItem>
                {!pathname.includes(ROUTES_NAMES.notifyEvent) && !pathname.includes(ROUTES_NAMES.notifyEventPatient) && (
                    <NavMenu>
                        <NavLinkExternal to={ROUTES_NAMES.notifications}> Notificações </NavLinkExternal>
                        <NavLinkExternal to={ROUTES_NAMES.reports}> Relatórios </NavLinkExternal>
                        <NavLinkExternal to={ROUTES_NAMES.configurationsRoutes.configurations} > Configurações </NavLinkExternal>
                        <NavLinkExternal to={ROUTES_NAMES.notifyEvent}> Notificar um evento </NavLinkExternal>
                    </NavMenu>
                )}
                <NavItem>
                    <Link id={'handle-login'} data-testid={'handle-login'} to="/" className='py-3'>
                        <IconLoginExternal />
                    </Link>
                </NavItem>
            </NavExternal>
        </>
    )
}